<template>
    <div>
        <ts-page-title :title="$t('serviceQuotation.pageTitle')" :breadcrumb="[
            { text: $t('home'), href: '/' },
            {
                text: $t('serviceQuotation.pageTitle'),
                href: '/admin/service-quotations'
            },
            {
                text: $t('create'),
                active: true
            }
        ]" />
        <ts-panel>
            <ts-panel-wrapper>
                <ts-loading-banner :loading="loading">
                    <div class="row">
                        <div class="col-md-12">
                            <Info v-model="model" :validate="errors" :loading.sync="loading" />
                        </div>
                    </div>
                    <div class="row ts-pt-4">
                        <div class="col-md-12">
                            <Detail v-model="model" :validate="errors" />
                        </div>
                    </div>
                    <div class="row ts-pt-4">
                        <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
                            <ts-button @click.prevent="
                                $router.push({
                                    name: 'service-quotation'
                                })
                                ">{{ $t('cancel') }}</ts-button>
                            <ts-button color="primary" :waiting="loading" @click.prevent="save">
                                {{ $t('save') }}
                            </ts-button>
                        </div>
                    </div>
                </ts-loading-banner>
            </ts-panel-wrapper>
        </ts-panel>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/info.vue'
import Detail from './components/detail.vue'
import { mapActions } from 'vuex'

export default {
    name: 'quotationCreate',
    components: {
        Detail,
        Info
    },
    data() {
        return {
            errors: new Errors(),
            loading: false,
            src: null,
            model: {
                quotation_date: moment().format('DD-MM-YYYY'),
                service_ticket_id: null,
                quotation_status_id: 1,
                sub_total: 0,
                discount_type: '%',
                discount_rate: 0,
                discount_amount: 0,
                total_after_discount: 0,
                vat_rate: 0,
                vat_amount: 0,
                grand_total: 0,
                remarks: null,
                charge_status: 'charged',
                details: [],
            }
        }
    },
    methods: {
        ...mapActions('customerService/serviceQuotation', ['getFormViewModel', 'store']),
        async fetchResources() {
            this.loading = true
            await this.getFormViewModel({ params: {}, index: undefined })
            this.loading = false
        },
        saveAddNew() {
            this.loading = true
            this.show_pdf = true
            this.errors = new Errors()
            this.store(this.model)
                .then(response => {
                    this.src = response.url
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.clearInput()
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                    this.show_pdf = false
                })
                .finally(() => {
                    this.loading = false
                })
        },
        save() {
            this.loading = true
            this.errors = new Errors()
            this.$store
                .dispatch('customerService/serviceQuotation/store', this.model)
                .then(response => {
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.$router.push({ name: 'service-quotation' })
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clearInput() {
            this.errors = new Errors()
            this.model.quotation_date = moment().format('DD-MM-YYYY')
            this.model.service_ticket_id = null
            this.model.quotation_status_id = 1
            this.model.sub_total = 0
            this.model.discount_type = '%'
            this.model.discount_rate = 0
            this.model.discount_amount = 0
            this.model.total_after_discount = 0
            this.model.vat_rate = 0
            this.model.vat_amount = 0
            this.model.grand_total = 0
            this.model.remarks = null
            this.model.details = []
        },
        notice(not) {
            this.$Notice[not.type]({
                title: 'SERVICE QUOTATION',
                desc: not.text
            })
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchResources()
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('customerService/serviceQuotation/RESET_STATE')
        next()
    }
}
</script>
